import { useState } from "react";
import "./style.css";

export default function DeleteConversationModal({ 
  conversation, 
  currentUser,
  onDelete, 
  onClose, 
  isVisible 
}) {
  const [selectedOption, setSelectedOption] = useState('for_me');

  const deleteOptions = [
    { 
      value: 'for_me', 
      label: 'Delete for me', 
      description: 'Remove this conversation from your chat list. The other person will still see it.',
      icon: <span className="notranslate">👤</span>,
      color: '#ff6b6b'
    },
    { 
      value: 'for_everyone', 
      label: 'Delete for everyone', 
      description: 'Remove this conversation for both you and the other person. This action cannot be undone.',
      icon: '🗑️',
      color: '#e41e3f'
    }
  ];

  const handleDelete = () => {
    const deleteForEveryone = selectedOption === 'for_everyone';
    onDelete(deleteForEveryone);
  };

  const getConversationName = () => {
    if (conversation.type === 'group') {
      return conversation.name || 'Group Chat';
    }
    
    const otherUser = conversation.participants.find(p => p._id !== currentUser?.id);
    return otherUser ? `${otherUser.first_name} ${otherUser.last_name}` : 'Unknown User';
  };

  if (!isVisible) return null;

  return (
    <div className="delete_conversation_modal_overlay" onClick={onClose}>
      <div className="delete_conversation_modal" onClick={(e) => e.stopPropagation()}>
        <div className="delete_conversation_header">
          <h3>Delete Conversation</h3>
          <button className="close_btn" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>
        
        <div className="delete_conversation_content">
          <p className="delete_description">
            Choose how you want to delete the conversation with <strong>{getConversationName()}</strong>:
          </p>
          
          <div className="delete_options">
            {deleteOptions.map((option) => (
              <label 
                key={option.value} 
                className={`delete_option ${selectedOption === option.value ? 'selected' : ''}`}
                style={{ borderColor: selectedOption === option.value ? option.color : 'transparent' }}
              >
                <input
                  type="radio"
                  name="deleteOption"
                  value={option.value}
                  checked={selectedOption === option.value}
                  onChange={(e) => setSelectedOption(e.target.value)}
                />
                <div className="delete_option_content">
                  <div className="delete_option_header">
                    <span className="delete_option_icon" style={{ color: option.color }}>{option.icon}</span>
                    <span className="delete_option_label">{option.label}</span>
                  </div>
                  <p className="delete_option_description">{option.description}</p>
                </div>
              </label>
            ))}
          </div>
        </div>
        
        <div className="delete_conversation_actions">
          <button className="cancel_btn" onClick={onClose}>
            Cancel
          </button>
          <button 
            className="delete_btn" 
            onClick={handleDelete}
            style={{ 
              backgroundColor: selectedOption === 'for_everyone' ? '#e41e3f' : '#ff6b6b' 
            }}
          >
            Delete Conversation
          </button>
        </div>
      </div>
    </div>
  );
} 